import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import HeroSection from '../components/HeroSection';
import InfoSection from '../components/InfoSection';
import './HomePage.css';
import BannerSection from '../components/BannerSection';
import EthosSection from '../components/EthosSection';
import PopularDishes from '../components/PopularDishes';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';

const HomePage = ({ restaurant }) => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate()

  useEffect(() => {
    setShowModal(true);
  }, []);

  const getRandomItemsFromCategories = () => {
    const allItems = [];

    for (let i = 0; i <= 23; i++) {
      const items = restaurant?.Categories[i]?.Items || [];
      allItems.push(...items);
    }

    return allItems.sort(() => Math.random() - 0.5);
  };

  const randomItems = getRandomItemsFromCategories();

  return (
    <div className="homepage-wrapper">
      {/* Announcement Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>🎉 Our New Website is Live!</Modal.Title>
        </Modal.Header>
<Modal.Body className="text-center text-dark">
  <p className="mb-4 fs-6">
    We’re excited to announce the launch of our brand-new website. <br />
    <span style={{ color: '#ba9131', fontWeight: 'bold' }}>
      Order directly from us
    </span>{' '}
    to skip the line, save time, and{' '}
    <span style={{ color: '#ba9131', fontWeight: 'bold' }}>
      join our rewards system!
    </span>
  </p>

  <a
    href="https://www.google.com/maps?q=815+E+78th+St,+Minneapolis,+MN+55420"
    target="_blank"
    rel="noopener noreferrer"
    className="d-block mx-auto border rounded px-4 py-3 text-decoration-none"
    style={{
      maxWidth: '420px',
      backgroundColor: '#fff5dc',
      borderColor: '#f2ddab',
      color: '#ba9131',
      fontWeight: '600',
      transition: 'background-color 0.3s ease',
    }}
    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#ffeebf')}
    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#fff5dc')}
  >
    📍 <span style={{ fontWeight: 'bold' }}>New Location:</span> 815 E 78th St, Minneapolis, MN 55420
  </a>
</Modal.Body>


        <Modal.Footer>
        <Button style={{ backgroundColor: '#ba9131', borderColor: '#ba9131' }} onClick={() => navigate('/order')}>
        Start Ordering
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Background and Content */}
      <div className="blurred-background"></div>
      <div className="homepage-content">
        <div style={{ marginTop: '70px' }}>
          <HeroSection />
          <InfoSection />
          <BannerSection />
          <EthosSection />
          <PopularDishes dimsum={randomItems} />
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default HomePage;
